:host {
  background-color: var(--white-layout-301-level-0-elevation);
  max-width: 100%;
}

#tab-group {
  --tab-header-padding-left: calc(var(--spacer) * 2.5);
}

.resources-tab-content {
  display: flex;
  flex-direction: column;
  gap: calc(var(--spacer) * 5);
  padding-top: calc(var(--spacer) * 3);
  padding-left: calc(var(--spacer) * 2.5);
  padding-right: calc(var(--spacer) * 2.5);
}

#back-button {
  display: flex;
  align-items: center;
  cursor: pointer;

  ::part(button) {
    background-color: transparent !important;
    border: none !important;
  }

  ::part(svgIcon) {
    fill: var(--body-text-arrows-400);
    transition: all 0.3s ease 0s;
  }

  &:hover {
    ::part(button) {
      color: var(--chart-301-icon-buttons);
    }
  
    ::part(svgIcon) {
      fill: var(--chart-301-icon-buttons);
    }
  }
}

.header-section {
  display: flex;
  align-items: center;
  padding-top: calc(var(--spacer) * 2.5);
  padding-bottom: calc(var(--spacer) * 2.5);
  padding-left: calc(var(--spacer) * 2.5);
}

gz-page-navigation-header {
  margin-top: calc(var(--spacer) * 0.75);
  margin-left: calc(var(--spacer) * 4);
}
